import { render } from "./ElemGrup.vue?vue&type=template&id=cb6dd8ce&scoped=true"
import script from "./ElemGrup.vue?vue&type=script&lang=js"
export * from "./ElemGrup.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada.css?vue&type=style&index=0&id=cb6dd8ce&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb6dd8ce"]])

export default __exports__